export const enum ProcessingStatus {
  AGREEMENT_SIGNING = 'agreement_signing',
  OFF = 'off',
  PAYMENT_SUCCESS = 'payment_success',
  PAYMENT_WAITING = 'payment_waiting',
}
